/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deactivate_AccountInputs */

const en_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate Account`)
};

const es_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivar cuenta`)
};

const fr_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver le compte`)
};

const de_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto deaktivieren`)
};

const ja_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを非有効化する`)
};

const zh_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停用账号`)
};

const ar_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعطيل الحساب`)
};

const id_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nonaktifkan Akun`)
};

const it_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disattiva Account`)
};

const ru_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Деактивировать аккаунт`)
};

const pt_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar Conta`)
};

const ko_deactivate_account = /** @type {(inputs: Deactivate_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 비활성화`)
};

/**
* | output |
* | --- |
* | "Deactivate Account" |
*
* @param {Deactivate_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const deactivate_account = /** @type {((inputs?: Deactivate_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deactivate_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deactivate_account(inputs)
	if (locale === "es") return es_deactivate_account(inputs)
	if (locale === "fr") return fr_deactivate_account(inputs)
	if (locale === "de") return de_deactivate_account(inputs)
	if (locale === "ja") return ja_deactivate_account(inputs)
	if (locale === "zh") return zh_deactivate_account(inputs)
	if (locale === "ar") return ar_deactivate_account(inputs)
	if (locale === "id") return id_deactivate_account(inputs)
	if (locale === "it") return it_deactivate_account(inputs)
	if (locale === "ru") return ru_deactivate_account(inputs)
	if (locale === "pt") return pt_deactivate_account(inputs)
	return ko_deactivate_account(inputs)
});